import { apiSlice } from "./authApi";

const appointmentApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAppointments: builder.query({
            providesTags: (result, error) => {
                if (result?.results) {
                    return result.results.map(appointment => ({
                        type: "Appointment",
                        id: appointment.id,
                    }));
                } 
                return [{ type: "Appointment", id: "List" }];     
            },
            query: ({ page = 1, pageSize = 5 } = {}) => ({
                url: `/appointments/?page=${page}&pageSize=${pageSize}`,
                method: "GET",
            }),
        }),

        getAppointment: builder.query({
            query: (id) => ({ url: `/appointments/${id}/` }),
            providesTags: (result, error, id) => [{ type: "Appointment", id }],
        }),

        deleteAppointment: builder.mutation({
            invalidatesTags: (result, error, id) => {
                return [{ type: "Appointment", id }];
            },
            query: (id) => {
                return {
                    url: `/appointments/${id}/`,
                    method: "DELETE",
                };
            },
        }),

        createAppointment: builder.mutation({
            invalidatesTags: (result, error, appointment) => {
                return [
                    {
                        type: "Appointment",
                        id: appointment.id,
                    },
                ];
            },
            query: (appointment) => {
                return {
                    url: "/appointments/",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: appointment,
                };
            },
        }),

        updateAppointment: builder.mutation({
            query: (appointment) => ({
                url: `/appointments/${appointment.id}/`,
                method: "PATCH",
                body: { ...appointment },
                headers: {
                    "Content-Type": "application/json",
                },
            }),
            invalidatesTags: (result, error, appointment) => {
                return [
                    {
                        type: "Appointment",
                        id: appointment.id,
                    },
                ];
            },
        }),
    }),
});

export const {
    useGetAppointmentsQuery,
    useGetAppointmentQuery,
    useCreateAppointmentMutation,
    useUpdateAppointmentMutation,
    useDeleteAppointmentMutation
} = appointmentApi;

export { appointmentApi };
